
import React, { useState, useEffect } from "react";
import { Radio } from "@mui/material";

const handleFullScreen = (image) => {
  if (image && image.includes('http')) {
    window.open(image, "_blank");
  }
};
const CreativesSelectableTableRows = ({ promotionsList, handleCreativeSelect }) => {
  const [selectedCreativeId, setSelectedCreativeId] = useState(null);
  const [defaultCreativeId, setDefaultCreativeId] = useState(null);

  useEffect(() => {
    // Find the default selected creative based on bitActive
    const defaultCreative = promotionsList?.find((i) => i.bitActive);
    if (defaultCreative) {
      setDefaultCreativeId(defaultCreative.intCreativeID);
      setSelectedCreativeId(defaultCreative.intCreativeID);
    }
  }, [promotionsList]);

  const handleApply = () => {
    if (selectedCreativeId) {
      handleCreativeSelect(selectedCreativeId);
    }
    // Revert to default after applying
    setSelectedCreativeId(defaultCreativeId);
  };

  return (
    <>
      {promotionsList && promotionsList.length > 0 ? (
    <>
      <table className="min-w-full divide-y divide-gray-300" style={{ width: "100%" }}>
        <thead className="bg-gray-50">
          <tr>
            <th
              scope="col"
              className="whitespace-nowrap px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color"
            >
              Name
            </th>
                <th
                  scope="col"
                  className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color text-center"
                >
                  Right Board
                </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color text-center"
            >
              Horizontal Flavor Board
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color text-center"
            >
              Vertical Flavor Board
            </th>
            <th
              scope="col"
              className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color text-center"
            >
              Select
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200 bg-white">
          {promotionsList?.map((i) => (
            <tr key={i?.intBannerID} className="item-container" style={{ width: "100%" }}>
              <td className="whitespace-nowrap px-3 py-1 text-sm text-gray-500">
                <div className="text-gray-700">{i?.vchCreativeName}</div>
              </td>
              <td className="whitespace-nowrap px-3 py-1 text-sm text-gray-500">
                <div className="text-gray-700" style={{ display: "flex", justifyContent: "center" }}>
                  <img
                    width="85px"
                    height="85px"
                    src={i?.vchImageURL1}
                    onError={(event) => {
                      event.target.src = "../assets/icons/notfound.png";
                      event.onerror = null;
                    }}
                    alt="The current file"
                    onClick={() => handleFullScreen(i?.vchImageURL1)}
                  />
                </div>
              </td>
              <td className="whitespace-nowrap px-3 py-1 text-sm text-gray-500">
                <div className="text-gray-700" style={{ display: "flex", justifyContent: "center" }}>
                  <img
                    width="85px"
                    height="85px"
                    src={i?.vchImageURL2}
                    onError={(event) => {
                      event.target.src = "../assets/icons/notfound.png";
                      event.onerror = null;
                    }}
                    alt="The current file"
                    onClick={() => handleFullScreen(i?.vchImageURL2)}
                  />
                </div>
              </td>
              <td className="whitespace-nowrap px-3 py-1 text-sm text-gray-500">
                <div className="text-gray-700" style={{ display: "flex", justifyContent: "center" }}>
                  <img
                    width="85px"
                    height="85px"
                    src={i?.vchImageURL3}
                    onError={(event) => {
                      event.target.src = "../assets/icons/notfound.png";
                      event.onerror = null;
                    }}
                    alt="The current file"
                    onClick={() => handleFullScreen(i?.vchImageURL3)}
                  />
                </div>
              </td>
              <td align="center" className="whitespace-nowrap px-3 py-1 text-sm text-gray-500">
                <Radio
                  value={i.intCreativeID}
                  checked={selectedCreativeId === i.intCreativeID}
                  onChange={() => setSelectedCreativeId(i.intCreativeID)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
          <div
            style={{
              paddingBottom: "20px",
              display: "flex",
              justifyContent: "end",
              paddingRight: "20px",
            }}
          >
            <button
              style={{ height: "38px", width: "120px" }}
              type="button"
              onClick={handleApply}
              className="inline-flex items-center justify-center rounded-md border border-transparent bg-primary px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-primary-light focus:ring-offset-2 sm:w-auto"
            >
              Apply
            </button>
          </div>
    </>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "10vh",
            fontSize: "16px",
            color: "gray",
          }}
        >
          No Promotions Available
        </div>
      )}
    </>
  )
};

export default CreativesSelectableTableRows;

